export default __webpack_public_path__ + "static/media/prompt.fe8436f4.png";